"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataType = void 0;
/**
 * Enum to indicate a Data Type.
 */
class DataType {
    // @ts-ignore
    constructor(_isPrimitive) {
        this._isPrimitive = _isPrimitive;
    }
    /**
     * Flag to indicate if the data type is primitive or complex.
     *
     * @return true if primitive, false otherwise
     */
    get isPrimitive() {
        return this._isPrimitive;
    }
}
exports.DataType = DataType;
DataType.STRING = new DataType(true);
DataType.INT = new DataType(true);
DataType.BOOLEAN = new DataType(true);
DataType.CONFIGURATION_DATA = new DataType(false);
DataType.ENUM = new DataType(true);
//# sourceMappingURL=data-type.js.map